import React, {ReactNode} from "react";

export function BoxWrpr(props: { fg: number, center?: boolean, children: ReactNode}) {
    return <div className={`flex text-center basis-0 flex-grow-[${props.fg}] justify-${props.center ? "center" : "initial"} text-[12px] notebook:!text-[14px]`}>
        {props.children}
    </div>
}
